var _rect, _path, _circle, _path2, _path3, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeycryptShieldX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 520,
    fill: "#111827"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400 88 610 165v120c0 106-87 163-210 197-123-34-210-91-210-197V165z",
    fill: "#164e63",
    stroke: "#67e8f9",
    strokeWidth: 8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 258,
    r: 58,
    fill: "#22d3ee"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M400 220v75M365 258h70",
    stroke: "#083344",
    strokeWidth: 15
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M180 405h440",
    stroke: "#0e7490",
    strokeWidth: 8,
    strokeDasharray: "18 16"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 75,
    fill: "#cffafe",
    fontFamily: "sans-serif",
    fontSize: 36,
    fontWeight: 700
  }, "KEYCRYPT SHIELD X")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 475,
    fill: "#67e8f9",
    fontFamily: "monospace",
    fontSize: 22
  }, "POLICY-DRIVEN CRYPTOGRAPHY")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeycryptShieldX);
export default __webpack_public_path__ + "static/media/keycrypt-shield-x.f95a19dcca93b1ed4a97fd1f36cf1cbb.svg";
export { ForwardRef as ReactComponent };